export default "__VITE_ASSET__nj$HFmVX__"